import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as reportsActions from '../../actions/Reports';
import { TabContent, TabPane } from 'reactstrap';

class Aside extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    const {statuses} = this.props;

    return (
      <aside className="aside-menu">
        <TabContent activeTab="1">
          <TabPane tabId="1">
            {statuses.map((item, index) => (
              <div className="message" key={index}>
                <small className="text-muted" style={{marginLeft: 10}}>
                  {item.msg}
                </small>
                <hr />
              </div>
            ))}
          </TabPane>
        </TabContent>
      </aside>
    );
  }
}

class AsideContainer extends Component {
  render() {
    return <Aside
      {...this.props}
      {...bindActionCreators({
        ...reportsActions,
      }, this.props.dispatch)} />;
  }
}

AsideContainer = connect(state => ({
  mcId: state.reports.get('mcId'),
  statuses: state.reports.get('statuses'),
  selectedLocale: state.reports.get('selectedLocale'),
  translations: state.reports.get('translations'),
}))(AsideContainer);

export default AsideContainer;



// WEBPACK FOOTER //
// ./src/components/Aside/Aside.js